import { Link } from "@quintype/components";
import React from "react";
import Cardimage from "../../atoms/cardimage";
import "./story-card15.m.css";
import StoryDate from "../../atoms/story-date";
import Headline from "../../atoms/headline";

function StoryCard15({ story, showSectionName = false, showDate = false, isTabViewEnabled = false }) {
  const { slug, headline, id } = story;
  return (
    <Link href={`/${slug}`}>
      <div styleName={isTabViewEnabled ? "tab-view-wrapper" : "wrapper"} className="story-card-15" id="story-card-15">
        <div styleName="image-section">
          <Cardimage
            story={story}
            aspectRatio={[16, 9]}
            imageType="image16x9"
            widths={[128, 240]}
            sizes="(max-width: 1024px) 1vw, 100vw"
            showVideoIcon={true}
          />
        </div>
        <div styleName="rhs">
          <span styleName="summary">
            <Headline
              text={headline}
              headerType={2}
              headerLevel={2}
              story={story}
              width={20}
              height={20}
              id={id}
              lineClamp={3}
              showSectionName={showSectionName}
            />
          </span>
          {showDate && <StoryDate story={story} />}
        </div>
      </div>
    </Link>
  );
}

export default StoryCard15;
